import React from 'react';
import classnames from 'classnames';
import { Panel } from 'react-bootstrap';
import LabeledCheckbox from '../LabeledCheckbox.jsx';
import { setProjectFilterResources } from '../../context/projectFilter.js';
import { useStateValue } from '../../context/state.jsx';

const FilterByResources = () => {
	const [{ datasets, currentDataset, projectFilter }, dispatch] = useStateValue();
	const datasetInfo = currentDataset && datasets ? datasets[currentDataset] : null;
	if (!datasetInfo) {
		return null;
	}
	const { filterOptions } = datasetInfo;

	const handleResourceChange = e => {
		dispatch(setProjectFilterResources(e.target.value, e.target.checked));
	};

	const resources = (filterOptions?.resources || []).map((resource, index) => {
		const checked = resource in projectFilter.resources;
		return (
			<LabeledCheckbox
				key={index}
				text={resource}
				textClass={checked ? 'isChecked' : ''}
				value={resource}
				checked={checked}
				onChange={handleResourceChange} />
		);
	});
	return (
		<Panel
			className={classnames({activeFilter: Object.keys(projectFilter.resources).length > 0})}>
			<Panel.Heading>
				<Panel.Title toggle>Resources</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<div className="labeledCheckboxGroup">{resources}</div>
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByResources;
